<template>
  <span id="cutoff-group-detail-section">
    <el-tooltip
      :content="$t('shipperCutoffGroup.viewDetailsTitle')"
      class="item"
      effect="dark"
      placement="top-start"
    >
      <i
        class="el-icon-search icon-action"
        id="btn-cutoff-group-detail-dialog"
        @click="handleOpenDialog"
        size="mini"
        icon="el-icon-plus"
      ></i>
    </el-tooltip>
    <el-dialog
      id="cutoff-group-detail-dialog"
      :close-on-click-modal="false"
      :title="$t('shipperCutoffGroup.viewDetailsTitle')"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <el-row :gutter="10">
        <el-col :span="5" class="list-name">
          <label class="margin-bottom-small-list">{{ $t('shipperCutoffGroup.name') }}</label>
        </el-col>
        <el-col :span="7">
          <span class="span-small-list">{{ name }}</span>
        </el-col>
        <el-col :span="5">
          <label class="margin-bottom-small-list">{{ $t('shipperCutoffGroup.numberOfShippers') }}</label>
        </el-col>
        <el-col :span="7">
          <span class="span-small-list blue-link-bold" @click="openShippersTab()">{{ numberOfShippers }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <span class="title-list">{{ $t('shipperCutoffGroup.schedule') }}</span>
        </el-col>
      </el-row>
      <el-form :model="editForm" ref="editForm" size="mini">
        <el-table
          :data="scheduleList"
          :empty-text="$t('common.notAbleToFindRecords')"
          v-loading="loadingSearch"
          id="cutoff-group-data-list"
          class="dark-blue-table"
          tooltip-effect="dark"
          size="mini"
          width="80%"
          stripe
        >
          <el-table-column
            prop="day"
            :label="$t('shipperCutoffGroup.day')"
            align="left"
            header-align="center"
            :min-width="5"
          ></el-table-column>
          <el-table-column
            :label="$t('shipperCutoffGroup.dataEntryCutoff')"
            align="center"
            :min-width="7"
          >
            <template slot-scope="scope">
              <el-form-item v-if="$can(permissions.WAREHOUSE.EDIT_SHIPPER_CUTOFF_GROUP)" v-show="scope.row.edit" prop="dataEntryCutOff">
                <el-time-select
                  class="inline-input"
                  size="mini"
                  clearable
                  v-model="editForm.dataEntryCutOff"
                  :picker-options="datePickerHourOptions"
                ></el-time-select>
              </el-form-item>
              <span v-show="!scope.row.edit">{{ scope.row.dataEntryCutOff }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('shipperCutoffGroup.receivingCutoff')"
            align="center"
            :min-width="7"
          >
            <template slot-scope="scope">
              <el-form-item v-if="$can(permissions.WAREHOUSE.EDIT_SHIPPER_CUTOFF_GROUP)" v-show="scope.row.edit" prop="receivingCutOff">
                <el-time-select
                  class="inline-input"
                  size="mini"
                  clearable
                  v-model="editForm.receivingCutOff"
                  :picker-options="datePickerHourOptions"
                ></el-time-select>
              </el-form-item>
              <span v-show="!scope.row.edit">{{ scope.row.receivingCutOff }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('common.options')"
            align="center"
            :min-width="5"
          >
            <template v-if="$can(permissions.WAREHOUSE.EDIT_SHIPPER_CUTOFF_GROUP)" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('common.edit')"
                placement="top-start"
              >
                <i v-show="!scope.row.edit && !editing" class="el-icon-edit icon-action" @click="handleEdit(scope.row)" />
              </el-tooltip>
              <el-button v-show="scope.row.edit" icon="el-icon-success" circle size="mini" @click="handleUpdate(scope.row)" />
              <el-button v-show="scope.row.edit" icon="el-icon-circle-close" circle size="mini" @click="cancelEdit(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-dialog>
  </span>
</template>

<script>
import moment from 'moment';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import { SHIPPER_CUTOFF_GROUP_DETAIL, SHIPPER_CUTOFF_GROUP_EDIT_DETAIL } from '@/store/actions';

export default {
  name: 'CutoffGroupDetailDialog',
  props: {
    shipperCutoffGroupId: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    numberOfShippers: {
      type: Number,
      required: true
    },
  },
  computed: {
    datePickerHourOptions() {
      return {
        step: '00:30',
        start: '00:00',
        end: '23:59'
      };
    }
  },
  data() {
    return {
      dialogVisible: false,
      loadingSearch: false,
      scheduleList: [],
      editing: false,
      editForm: {
        dataEntryCutOff: null,
        receivingCutOff: null,
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.editing = false;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.getSchedule();
      });
    },
    getSchedule() {
      this.editing = false;
      this.loadingSearch = true;
      this.$store.dispatch(SHIPPER_CUTOFF_GROUP_DETAIL, this.shipperCutoffGroupId).then((response) => {
        this.scheduleList = response.data.map((schedule) => {
          schedule.edit = false;
          return schedule;
        });
      }).finally(() => {
        this.loadingSearch = false;
      });
    },
    openShippersTab() {
      const routeData = this.$router.resolve({
        path: '/warehouse/manageShippers',
        query: {
          shipperCutoffGroupId: this.shipperCutoffGroupId,
          shipperCutoffGroupName: this.name,
        }
      });
      window.open(routeData.href, '_blank');
    },
    handleEdit(row) {
      if (row.dataEntryCutOff) {
        this.editForm.dataEntryCutOff = moment(row.dataEntryCutOff, [
          moment.ISO_8601,
          'HH:mm'
        ]).format('HH:mm');
      } else {
        this.editForm.dataEntryCutOff = null;
      }

      if (row.receivingCutOff) {
        this.editForm.receivingCutOff = moment(row.receivingCutOff, [
          moment.ISO_8601,
          'HH:mm'
        ]).format('HH:mm');
      } else {
        this.editForm.receivingCutOff = null;
      }

      row.edit = true;
      this.editing = true;
    },
    cancelEdit(row) {
      row.edit = false;
      this.editing = false;
    },
    handleUpdate(row) {
      const ediData = {
        shipperCutoffGroupId: this.shipperCutoffGroupId,
        dayOfWeek: row.day,
        schedule: { ...this.editForm }
      };
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store
        .dispatch(SHIPPER_CUTOFF_GROUP_EDIT_DETAIL, ediData)
        .then((response) => {
          loading.close();
          this.getSchedule();
          this.$message.success(response.message);
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
span#cutoff-group-detail-section {
  th {
    line-height: 1.15;
    .cell {
      line-height: 16px;
      height: 16px;
    }
  }

  .dark-blue-table.el-table tbody tr td {
    .el-input {
      width: 100%;

      .el-input__inner {
        padding-left: 30px;
      }

      .el-input__icon {
        line-height: 24px;
      }
    }
  }
}
</style>
